import { Link } from "react-router-dom";
import Reveal from "../components/Reveal";
import { LogoMark } from "../components/Logo";
import { usePageMeta } from "../hooks/usePageMeta";

export default function NotFound() {
  usePageMeta({ title: "Page not found | Clearriver Studios", noindex: true });
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6 text-center">
      <LogoMark size={44} className="opacity-80" />
      <p className="eyebrow mt-8">404</p>
      <h1 className="h-display mt-4 text-[clamp(40px,6vw,72px)]">Page not found.</h1>
      <p className="measure mt-5 max-w-md text-[16.5px] text-dim">
        The page you&rsquo;re looking for doesn&rsquo;t exist or has moved.
      </p>
      <Link to="/" className="btn-primary mt-10" data-testid="notfound-home-link">
        Back to home
      </Link>
    </div>
  );
}
